module.exports = __webpack_public_path__ + "static/media/n_icon_shuoming@2x.faa125fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_shuoming@2x.png
// module id = 1812
// module chunks = 0 1